<div>
  <div class="margin-top-20 add-person-button">
    <div class="purple font-12" (click)="openAddContactModal(null)">
      <b><i class="fas fa-user-plus"></i> Add Information Designee</b>
    </div>
  </div>
  <div class="user-card">
    <div class="uk-flex uk-flex-nowrap">
      <div class="fullwidth">
        <p class="font-13"><b>Information Designee</b></p>
        <p class="grey font-13 contacts__how-many-users">
          <span> {{ designeeControl.length }} users </span>
          <span *ngIf="designeeControl.length > 1 && userType !== UserTypeEnum.ADMIN" class="pointer" (click)="showAllDesigneeControl()">
            <span *ngIf="designeeControllength < 2">Show more</span><span *ngIf="designeeControllength > 1">Show less</span>
          </span>
        </p>
      </div>
      <div class="uk-text-right">
      </div>
    </div>
    <div *ngIf="designeeControl.length > 0">
      <ul class="box-list-sidebar">
        <li
          *ngFor="
            let listItem of designeeControl | slice: 0:designeeControllength;
            let i = index
          "
          (click)="openAddContactModal(listItem)"
        >
          <div class="uk-flex uk-flex-nowrap">
            <div class="box-text">
              <p class="purple font-13">
                <b>{{ listItem.first_name }} </b>
                <b>{{ listItem.last_name }}</b>
                <img class="contact-status-indicator"
                  [src]="listItem.status === ContactEnum.STATUS_ACTIVE ?
                          '/assets/images/green-check-mark.png':
                          '/assets/images/orange-question-mark.png'
                        "
                  [title]="listItem.status === ContactEnum.STATUS_ACTIVE ?
                          'Request accepted.':
                          'Request pending.'
                        "
                />
              </p>
              <p class="font-12 grey lowercase">{{ listItem.email }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="user-card">
    <div class="uk-flex uk-flex-nowrap">
      <div class="fullwidth">
        <p class="font-13"><b>Other Contacts</b></p>
        <p class="grey font-13 contacts__how-many-users">
          <span> {{ otherContacts.length }} users </span>
          <span *ngIf="otherContacts.length > 1 && userType !== UserTypeEnum.ADMIN" class="pointer" (click)="showAllOtherContacts()">
            <span *ngIf="otherContactslength < 2">Show more</span><span *ngIf="otherContactslength > 1">Show less</span>
          </span>
        </p>
      </div>
      <div class="uk-text-right">
      </div>
    </div>
    <div *ngIf="designeeControl.length > 0">
      <ul class="box-list-sidebar">
        <li
          *ngFor="
            let listItem of otherContacts | slice: 0:otherContactslength;
            let i = index
          "
          (click)="openAddContactModal(listItem)"
        >
          <div class="uk-flex uk-flex-nowrap">
            <div class="box-text">
              <p class="purple font-13">
                <b>{{ listItem.first_name }} </b>
                <b>{{ listItem.last_name }}</b>
              </p>
              <p class="font-12 grey lowercase">{{ listItem.email }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
